import exhibitService from "../../services/exhibitService";
import { getField, updateField } from "vuex-map-fields";

const state = {
  exhibits: [],
  surveyExhibits: []
}

const getters = {
  getField,
  exhibits: state => {
    return state.exhibits;
  }
};

const actions = {
  updateField,
  fetchExhibits({ commit }) {
    exhibitService.fetchExhibits().then(response => {
      commit("GET_EXHIBITS", response.data);
    });
  },
  updateExhibits({ commit }, exhibit) {
    commit("ADD_EXHIBIT", exhibit);
  },
  deleteExhibit({ commit }, exhibit) {
    exhibitService.deleteExhibit(exhibit).then(() => {
      commit("REMOVE_EXHIBIT", exhibit)
    })
  },
  editExhibitName({ commit }, payload) {
    exhibitService.editExhibitName(payload.exhibit, payload.name).then(response => {
      commit("UPDATE_EXHIBIT", response.data)
    })
  },
  getSurveyExhibits({ commit }, survey) {
    exhibitService.getSurveyExhibits(survey).then(response => {
      commit("GET_SURVEY_EXHIBITS", response.data)
    })
  }
}

const mutations = {
  GET_EXHIBITS(state, exhibits) {
    state.exhibits = exhibits.map(obj=> ({ ...obj, edit: false }));
  },
  ADD_EXHIBIT(state, exhibit) {
    exhibit["edit"] = false
    state.exhibits.push(exhibit);
  },
  REMOVE_EXHIBIT(state, exhibit) {
    state.exhibits = state.exhibits.filter(obj => obj.pk !== exhibit.pk);
  },
  UPDATE_EXHIBIT(state, exhibit) {
    const index = state.exhibits.findIndex(x => x.pk === exhibit.pk);
    state.exhibits[index].name = exhibit.name;
    state.exhibits[index].edit = false;
  },
  GET_SURVEY_EXHIBITS(state, exhibits) {
    state.surveyExhibits = exhibits;
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};